'use client';

import React from 'react';
import styled from 'styled-components';
import { theme } from '@/config/theme';
import { i18n } from '@/config/i18n';

const BannerContainer = styled.div`
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  border-radius: ${theme.borderRadius.md};
  padding: 16px 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d97706;
`;

const WarningIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Message = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #92400e;
  line-height: 1.5;
`;

export interface UnderConstructionBannerProps {
  message?: string;
  className?: string;
}

export const UnderConstructionBanner: React.FC<UnderConstructionBannerProps> = ({
  message,
  className,
}) => {
  const displayMessage = message || i18n.common.messages.underConstruction;

  return (
    <BannerContainer className={className} role="alert" aria-live="polite">
      <IconWrapper>
        <WarningIcon />
      </IconWrapper>
      <Message>{displayMessage}</Message>
    </BannerContainer>
  );
};

